module.exports = __webpack_public_path__ + "img/hwdl8.b7f9ef3f.png";